import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import type { IconDefinition } from '@gitbook/spine-react';

/**
 * Definitions for the agent tasks.
 */
export const AGENT_TASKS_DEF: {
    [type in api.AIMessageTask['type']]: {
        icon: IconDefinition;
        label: string;
        processingLabel: string;
    };
} = {
    respond_to_comment: {
        icon: Icon.CommentThread,
        label: 'Responded to a comment',
        processingLabel: 'Responding to a comment',
    },
    review_change_request: {
        icon: Icon.ChangeRequestOpen,
        label: 'Reviewed change request',
        processingLabel: 'Reviewing change request',
    },
    implement_change_request: {
        icon: Icon.ChangeRequestDraft,
        label: 'Implemented change request',
        processingLabel: 'Implementing change request',
    },
    background_agent: {
        icon: Icon.Users,
        label: 'Background agent',
        processingLabel: 'Working in the background',
    },
};

/**
 * Whether the task is a run the agent was given a change request for, rather than a turn in a
 * conversation someone is having with it.
 *
 * Such a run *is* the conversation it happens in, so the tray under the transcript names it once —
 * and says the one thing a label never did: that a review can only be read, and that an
 * implementation keeps working in the background.
 */
export function isChangeRequestRunTask(task: api.AIMessageTask): boolean {
    return task.type === 'review_change_request' || task.type === 'implement_change_request';
}
